// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import loadStoreLists from "@store/Framework/Store/Pages/StoreLists/Handlers/LoadStoreLists";
import { StoreListModel } from "@store/Framework/Types/ApiModels";
import { AddStoreListApiParameter } from "@store/Services/StoreListService";
import { addStoreList as addStoreListApi } from "@store/Services/StoreListService";
import {
    createHandlerChainRunner,
    HandlerWithResult,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export interface AddStoreListResult {
    storeListModel?: StoreListModel;
    errorMessage?: string;
}

type HandlerType = HandlerWithResult<
    {
        apiParameter: AddStoreListApiParameter;
        reloadStoreLists?: boolean;
        onSuccess?: (addedStoreList: StoreListModel) => void;
        onError?: (errorMessage: string) => void;
    },
    AddStoreListResult
>;

export const DispatchBeginAddStoreList: HandlerType = props => {
    props.result = {};
    props.dispatch({
        type: "Pages/StoreLists/BeginAddStoreList",
    });
};

export const CallAddStoreListApi: HandlerType = async props => {
    try {
        props.result.storeListModel = await addStoreListApi(props.parameter.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

export const ResetStoreListsData: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/Reset",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.result.errorMessage && props.result.storeListModel && props.parameter.onSuccess) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess(props.result.storeListModel);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.result.errorMessage) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.result.errorMessage);
    }
};

export const DispatchCompleteAddStoreList: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreLists/CompleteAddStoreList",
        result: props.result,
    });
};

export const DispatchLoadStoreLists: HandlerType = props => {
    if (!props.result.errorMessage && props.result.storeListModel && props.parameter.reloadStoreLists) {
        props.dispatch(loadStoreLists());
    }
};

export const chain = [
    DispatchBeginAddStoreList,
    CallAddStoreListApi,
    ResetStoreListsData,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchCompleteAddStoreList,
    DispatchLoadStoreLists,
];

const addStoreList = createHandlerChainRunner(chain, "AddStoreList");
export default addStoreList;
